import { render, staticRenderFns } from "./evaluating-article-detail.vue?vue&type=template&id=85426fe4&scoped=true&"
import script from "./evaluating-article-detail.vue?vue&type=script&lang=js&"
export * from "./evaluating-article-detail.vue?vue&type=script&lang=js&"
import style0 from "./evaluating-article-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./evaluating-article-detail.vue?vue&type=style&index=1&id=85426fe4&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85426fe4",
  null
  
)

export default component.exports